module.exports = __webpack_public_path__ + "img/tertiary_11x2.6d981cdb.svg";